import styled, { keyframes } from "styled-components";

/* Mesma linguagem visual da tela de Contratos: fundo cinza, cartões brancos. */

const surgir = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const girar = keyframes`
  to { transform: rotate(360deg); }
`;

export const Pagina = styled.div`
  background: #f5f5f5;
  min-height: 100vh;
  padding: 22px 24px 48px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: #1a2740;
`;

const cartao = `
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(16, 44, 76, 0.08), 0 6px 18px rgba(16, 44, 76, 0.04);
`;

export const Cabecalho = styled.header`
  ${cartao}
  padding: 22px 26px;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  animation: ${surgir} 0.35s ease-out both;
`;

export const Identidade = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  h1 {
    font-size: 22px;
    font-weight: 800;
    margin: 0 0 3px;
    letter-spacing: -0.2px;
  }

  p {
    margin: 0;
    font-size: 13.5px;
    color: #7a8fa6;
    max-width: 620px;
    line-height: 1.5;
  }

  strong {
    color: #024995;
    font-weight: 700;
  }
`;

export const IconeTitulo = styled.div`
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 19px;
  flex-shrink: 0;
  background: #024995;
  background-image: linear-gradient(135deg, #024995 0%, #009bd9 100%);
`;

export const Contadores = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

export const Contador = styled.div<{ $cor: string; $fundo: string; $borda: string }>`
  min-width: 108px;
  padding: 10px 14px;
  border-radius: 12px;
  background: ${(p) => p.$fundo};
  border: 1.5px solid ${(p) => p.$borda};
  text-align: center;

  strong {
    display: block;
    font-size: 20px;
    font-weight: 800;
    color: ${(p) => p.$cor};
    line-height: 1.2;
  }

  span {
    display: block;
    font-size: 10.5px;
    font-weight: 800;
    letter-spacing: 0.7px;
    text-transform: uppercase;
    color: #8698ab;
    margin-top: 2px;
  }
`;

export const Abas = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 18px;
  flex-wrap: wrap;
`;

export const Aba = styled.button<{ $ativa: boolean }>`
  border: 1.5px solid ${(p) => (p.$ativa ? "#024995" : "#e8eef5")};
  background: ${(p) => (p.$ativa ? "#024995" : "#ffffff")};
  color: ${(p) => (p.$ativa ? "#ffffff" : "#5b6f85")};
  border-radius: 11px;
  padding: 10px 18px;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;

  i {
    margin-right: 7px;
  }

  &:hover {
    border-color: #024995;
    color: ${(p) => (p.$ativa ? "#ffffff" : "#024995")};
  }
`;

/*
  Aba de tipo: um degrau acima das outras, porque troca a lista inteira. Fica
  visualmente mais forte que a aba de estado para a hierarquia ficar óbvia.
*/
export const AbaTipo = styled.button<{ $ativa: boolean }>`
  border: none;
  border-bottom: 3px solid ${(p) => (p.$ativa ? "#024995" : "transparent")};
  background: transparent;
  color: ${(p) => (p.$ativa ? "#024995" : "#8698ab")};
  padding: 8px 4px 10px;
  margin-right: 22px;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease;

  i {
    margin-right: 8px;
  }

  &:hover {
    color: #024995;
  }
`;

export const Filtros = styled.section`
  ${cartao}
  padding: 18px 22px;
  margin-bottom: 18px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 14px;
  align-items: end;
  animation: ${surgir} 0.35s ease-out 0.04s both;
`;

export const Campo = styled.div`
  min-width: 0;

  label {
    display: block;
    font-size: 10.5px;
    font-weight: 800;
    letter-spacing: 0.9px;
    text-transform: uppercase;
    color: #8698ab;
    margin-bottom: 6px;
  }

  .entrada {
    position: relative;

    i {
      position: absolute;
      left: 13px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 13px;
      color: #b3c1d1;
      pointer-events: none;
    }
  }

  input {
    width: 100%;
    border: 1.5px solid #e8eef5;
    border-radius: 10px;
    padding: 10px 12px 10px 34px;
    font-size: 13.5px;
    color: #1a2740;
    background: #ffffff;
    outline: none;
    transition: border-color 0.15s ease;

    &:focus {
      border-color: #009bd9;
    }
  }
`;

export const BotaoLimpar = styled.button`
  border: 1.5px solid #e8eef5;
  background: #ffffff;
  color: #5b6f85;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
  height: 41px;

  i {
    margin-right: 6px;
  }

  &:hover {
    border-color: #dc3545;
    color: #dc3545;
  }
`;

export const BotaoPrincipal = styled.button`
  border: none;
  background: #024995;
  background-image: linear-gradient(135deg, #024995 0%, #009bd9 100%);
  color: #ffffff;
  border-radius: 11px;
  padding: 11px 20px;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  transition: filter 0.15s ease;

  i {
    margin-right: 7px;
  }

  &:hover:not(:disabled) {
    filter: brightness(1.08);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const BotaoSecundario = styled(BotaoLimpar)`
  &:hover {
    border-color: #024995;
    color: #024995;
  }
`;

export const Tabela = styled.section`
  ${cartao}
  animation: ${surgir} 0.35s ease-out 0.08s both;
  overflow: hidden;
`;

/*
  Cada linha é um grid próprio, então as colunas precisam de largura resolvível sem
  depender do conteúdo — senão cada linha calcula uma largura e a tabela sai de prumo.
*/
const grade = (colunas: string) => `
  display: grid;
  grid-template-columns: ${colunas};
  gap: 18px;
  align-items: center;
`;

export const Titulos = styled.div<{ $colunas: string }>`
  ${(p) => grade(p.$colunas)}
  padding: 13px 24px;
  background: #f7fafd;
  border-bottom: 1.5px solid #e8eef5;

  span {
    font-size: 10.5px;
    font-weight: 800;
    letter-spacing: 0.9px;
    text-transform: uppercase;
    color: #8698ab;
  }

  @media (max-width: 1100px) {
    display: none;
  }
`;

export const Linha = styled.div<{ $colunas: string }>`
  ${(p) => grade(p.$colunas)}
  padding: 15px 24px;
  border-bottom: 1px solid #f0f4f8;
  transition: background 0.15s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #fafcfe;
  }

  /* Abaixo de 1100px a tabela vira cards empilhados. */
  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 18px 20px;
    border-bottom: 8px solid #f5f5f5;
  }
`;

export const Celula = styled.div`
  min-width: 0;

  .principal {
    display: block;
    font-size: 14.5px;
    font-weight: 700;
    color: #1a2740;
    overflow-wrap: anywhere;
    margin-bottom: 2px;
  }

  .apoio {
    display: block;
    font-size: 12.5px;
    color: #8698ab;
    overflow-wrap: anywhere;
    line-height: 1.5;
  }

  /* Rótulo que só aparece no modo card, para a coluna não ficar sem contexto. */
  .rotulo {
    display: none;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    color: #b3c1d1;
    margin-bottom: 2px;
  }

  @media (max-width: 1100px) {
    .rotulo {
      display: block;
    }
  }
`;

export const Selo = styled.span<{ $tom: "ok" | "alerta" | "neutro" }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 11px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;

  background: ${(p) =>
    p.$tom === "ok" ? "#eafaf1" : p.$tom === "alerta" ? "#fff8ec" : "#eef2f7"};
  border: 1.5px solid
    ${(p) => (p.$tom === "ok" ? "#b7e4c7" : p.$tom === "alerta" ? "#ffd8a8" : "#e0e7ef")};
  color: ${(p) => (p.$tom === "ok" ? "#1b7a4b" : p.$tom === "alerta" ? "#a35b00" : "#5b6f85")};
`;

export const Vazio = styled.div`
  padding: 56px 24px;
  text-align: center;

  i {
    font-size: 40px;
    color: #cfdae7;
    margin-bottom: 14px;
    display: block;
  }

  h3 {
    font-size: 16px;
    font-weight: 700;
    margin: 0 0 6px;
  }

  p {
    font-size: 13.5px;
    color: #8698ab;
    margin: 0;
  }
`;

export const Carregando = styled.div`
  padding: 56px 24px;
  text-align: center;
  color: #8698ab;
  font-size: 13.5px;

  &::before {
    content: "";
    display: block;
    width: 30px;
    height: 30px;
    margin: 0 auto 14px;
    border: 3px solid #e8eef5;
    border-top-color: #024995;
    border-radius: 50%;
    animation: ${girar} 0.8s linear infinite;
  }
`;

export const Paginacao = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 24px;
  border-top: 1.5px solid #e8eef5;
  flex-wrap: wrap;

  .contagem {
    font-size: 12.5px;
    color: #8698ab;
  }

  .botoes {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  button {
    border: 1.5px solid #e8eef5;
    background: #ffffff;
    color: #5b6f85;
    border-radius: 9px;
    padding: 7px 13px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;

    &:disabled {
      opacity: 0.45;
      cursor: not-allowed;
    }

    &:hover:not(:disabled) {
      border-color: #024995;
      color: #024995;
    }
  }
`;

export const Aviso = styled.div`
  ${cartao}
  padding: 14px 18px;
  margin-bottom: 18px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  border-left: 4px solid #f39200;
  font-size: 13px;
  color: #5b6f85;
  line-height: 1.55;

  i {
    color: #f39200;
    font-size: 15px;
    margin-top: 2px;
  }

  strong {
    color: #1a2740;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(16, 32, 52, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 1080;
`;

export const Dialogo = styled.div`
  background: #ffffff;
  border-radius: 16px;
  width: 100%;
  max-width: 480px;
  overflow: hidden;
  box-shadow: 0 18px 50px rgba(10, 26, 46, 0.3);
`;

export const DialogoTopo = styled.div`
  padding: 18px 22px;
  background: #f39200;
  color: #ffffff;
  font-size: 16px;
  font-weight: 800;

  i {
    margin-right: 9px;
  }
`;

export const DialogoCorpo = styled.div`
  padding: 22px;
  font-size: 14px;
  line-height: 1.6;
  color: #3d4d5c;

  strong {
    color: #1a2740;
  }
`;

export const DialogoAcoes = styled.div`
  padding: 16px 22px;
  border-top: 1.5px solid #e8eef5;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;
